export default __webpack_public_path__ + "static/895-aebe92e2c84edb7341499dd9be4523d0.gif";